import {
  UserOutlined,
  TeamOutlined,
  KeyOutlined,
  ApiOutlined,
  GlobalOutlined,
} from '@ant-design/icons';

const footer = [
  // {
  //   path: '/game-list?gameType=REGULAR&currencyId=coin', // for demo purpose
  //   label: 'faq',
  // },
  // {
  //   path: '/game-list?gameType=REGULAR&currencyId=coin', // for demo purpose
  //   label: 'tnc',
  // },
  // {
  //   path: '/game-list?gameType=REGULAR&currencyId=coin', // for demo purpose
  //   label: 'about_us',
  // },
  // {
  //   path: '/game-list?gameType=REGULAR&currencyId=coin', // for demo purpose
  //   label: 'contact_us',
  // },
  {
    path: '/verification',
    label: 'settings',
    needFirstPartyGateway: true,
  },
  // {
  //   // hide lucky draw page
  //   // TODO enter lucky-draw page through here, otherwise err will be shown
  //   path: '/lucky-draw',
  //   label: 'lucky_draw',
  // },
];

export default footer;
